import React, { ReactNode } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      height: "100%",
      backgroundColor: theme.palette.background.paper,
      backgroundSize: "50px 50px",
      display: "flex",
      "> *": {
        height: "100%",
        minHeight: "100%",
        width: "100%"
      },
      backgroundImage: `linear-gradient(
            0deg,
            transparent 24%,
            rgba(0,0,0, 0.05) 25%,
            rgba(0,0,0, 0.05) 26%,
            transparent 27%,
            transparent 74%,
            rgba(0,0,0, 0.05) 75%,
            rgba(0,0,0, 0.05) 76%,
            transparent 77%,
            transparent
            ),
            linear-gradient(
            90deg,
            transparent 24%,
            rgba(0,0,0, 0.05) 25%,
            rgba(0,0,0, 0.05) 26%,
            transparent 27%,
            transparent 74%,
            rgba(0,0,0, 0.05) 75%,
            rgba(0,0,0, 0.05) 76%,
            transparent 77%,
            transparent
            )`
    }
  })
);

export interface TreeCanvasWidgetProps {
  children: ReactNode;
}
export const TreeCanvasWidget = (props: TreeCanvasWidgetProps) => {
  const classes = useStyles();
  return <div className={classes.container}>{props.children}</div>;
};
